import { lazy } from 'react';

const ReportGenerator = lazy(() => import('../pages/ReportGenerator'));
const ReportAccess = lazy(() => import('../pages/ReportAccess'));

const ReportGeneratorRoute = {
  public: [
    {
      name: 'access_redirect',
      path: '/access-redirect',
      component: ReportAccess,
    },
  ],
  auth: [
    {
      name: 'access_generator',
      path: '/report/access-generator',
      permissions: ['admin', 'COO', 'EXECUTIVE'],
      component: ReportGenerator,
    },
  ],
};

export default ReportGeneratorRoute;
